var __WEBPACK_NAMESPACE_OBJECT__ = require("prismjs/components/prism-perl.js");